import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { newsItem } from '../helpers';

export default function NewsSection({ searchFocused }) {
  const showAdminBtn = useSelector(state => state.user.showAdminBtn);
  
  return (
    <Container>
      <Row>
        <Col md={{ span: 10, offset: 1 }} lg={{ span: 8, offset: 2 }}>
          <div className={`mt-5 news-section${searchFocused ? ' search-focused' : ''}`}>
            <h2 className="title">Цікаве про медицину</h2>
            <ul className="news-list">
              {newsItem.map(({ icon: Icon, description, link, linkDescription }, index) => {
                // Check if link is internal (starts with /) or external
                const isInternalLink = link.startsWith('/');
                
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <li className="news-list__item" key={index}>
                    <div className="news-list__icon">
                      <Icon />
                    </div>
                    <div className="news-list__about">
                      <div className="news-list__description">{description}</div>
                      {isInternalLink ? (
                        <Link to={link} className="news-list__link">
                          <i className="fas fa-link" />
                          {linkDescription}
                        </Link>
                      ) : (
                        <a href={link} className="news-list__link" target="_blank" rel="noopener noreferrer">
                          <i className="fas fa-link" />
                          {linkDescription}
                        </a>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
            
            {showAdminBtn && (
              <div className="admin-panel-button mt-4">
                <Button 
                  variant="primary" 
                  href={process.env.REACT_APP_BASE_API_URL.replace('v2', 'admin/login')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-admin-panel"
                >
                  <i className="fas fa-user-shield me-2 pr-2" />
                  Кабінет адміністратора закладу
                </Button>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
